import { c as _c } from "react/compiler-runtime";
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import type { CtaAnalyticsProps } from '../model/types';
import { ApplyNowButton } from './ApplyNowButton';
export const ApplyNow = t0 => {
  const $ = _c(18);
  const {
    ctaAnalytics,
    creditCardOffer,
    sectionIdentifier,
    additionalApplyNowProps
  } = t0;
  const {
    details: t1,
    institution: t2,
    name
  } = creditCardOffer;
  const {
    applyLink,
    applyPhoneNumber,
    isActive,
    isMonetizing,
    reviewLink,
    termsFeesLink,
    versionId
  } = t1;
  const {
    name: institutionName
  } = t2;
  let t3;
  if ($[0] !== name) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /\s/g;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    t3 = name.toLowerCase().replace(t4, "-");
    $[0] = name;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const parsedName = `${t3}`;
  const id = sectionIdentifier ? `product-card-apply-now-${sectionIdentifier}-${parsedName}` : `product-card-apply-now-${parsedName}`;
  let t4;
  if ($[3] !== ctaAnalytics) {
    t4 = {
      ...ctaAnalytics,
      linkType: "APPLY_NOW_BUTTON"
    };
    $[3] = ctaAnalytics;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== additionalApplyNowProps || $[6] !== applyLink || $[7] !== applyPhoneNumber || $[8] !== id || $[9] !== institutionName || $[10] !== isActive || $[11] !== isMonetizing || $[12] !== name || $[13] !== reviewLink || $[14] !== t4 || $[15] !== termsFeesLink || $[16] !== versionId) {
    t5 = <ApplyNowButton id={id} isActive={isActive} isMonetizing={isMonetizing} applyLink={applyLink} termsFeesRedirectLink={termsFeesLink} reviewLink={reviewLink} applyPhoneNumber={applyPhoneNumber} institutionName={institutionName} analytics={t4} ctaType="APPLY_NOW_BUTTON" versionId={versionId} isSpanFullWidth={true} name={name} {...additionalApplyNowProps} />;
    $[5] = additionalApplyNowProps;
    $[6] = applyLink;
    $[7] = applyPhoneNumber;
    $[8] = id;
    $[9] = institutionName;
    $[10] = isActive;
    $[11] = isMonetizing;
    $[12] = name;
    $[13] = reviewLink;
    $[14] = t4;
    $[15] = termsFeesLink;
    $[16] = versionId;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};